import React from 'react'
import { Modal, Typography, Select } from 'antd'

import { ModalContentContainer } from '../modal.common'

const { Text } = Typography

export const ModalReject: React.FC<ModalRejectProps> = ({
	isOpened,
	onReject,
	onCancel,
	isLoading,
	reason,
	onSelectReason,
}) => (
	<Modal
		open={isOpened}
		title="환급 거절하기"
		okText="확인"
		cancelText="취소"
		closable={false}
		onOk={onReject}
		onCancel={onCancel}
		confirmLoading={isLoading}
	>
		<ModalContentContainer>
			<Text>환급 거절 사유</Text>
			<div style={{ marginTop: '5px' }}>
				<Select
					value={reason}
					placeholder="거절 사유를 선택해 주세요"
					options={[
						{ value: '중복 인증', label: '중복 인증' },
						{ value: '잘못된 인증', label: '잘못된 인증' },
						{ value: '기타', label: '기타' },
					]}
					onSelect={(value: string) => onSelectReason(value)}
					style={{ width: '100%' }}
				/>
			</div>
		</ModalContentContainer>
	</Modal>
)

export type ModalRejectProps = {
	isOpened: boolean
	onReject: () => void
	onCancel: () => void
	isLoading: boolean
	reason?: string
	onSelectReason: (reason: string) => void
}
